<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.duration"
            :error-messages="durationErrors"
            :label="$t('contract.duration')"
            required
            @input="$v.item.duration.$touch()"
            @blur="$v.item.duration.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('contract.guarantee') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.guarantee"
                :error-messages="guaranteeErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('contract.maintenance') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.maintenance"
                :error-messages="maintenanceErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-textarea
            v-model="item.description"
            :error-messages="descriptionErrors"
            :label="$t('contract.description')"
            auto-grow
            rows="1"
            row-height="15"
            @input="$v.item.description.$touch()"
            @blur="$v.item.description.$touch()"
          />
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Loading from '../../components/Loading';

export default {
  name: 'ContracttypeForm',
  mixins: [validationMixin],
  components: {
    Loading,
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {

  },
  data() {
    return {
        name: null,
        duration: null,
        description: null,
        maintenance: null,
        guarantee: null,
    };
  },
  computed: {
    isLoading() {
      return (
      false
       );
    },

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    durationErrors() {
      const errors = [];

      if (!this.$v.item.duration.$dirty) return errors;

      has(this.violations, 'duration') && errors.push(this.violations.duration);

      !this.$v.item.duration.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    descriptionErrors() {
      const errors = [];

      if (!this.$v.item.description.$dirty) return errors;

      has(this.violations, 'description') && errors.push(this.violations.description);


      return errors;
    },
    guaranteeErrors() {
      const errors = [];

      if (!this.$v.item.guarantee.$dirty) return errors;

      has(this.violations, 'guarantee') && errors.push(this.violations.guarantee);


      return errors;
    },
    maintenanceErrors() {
      const errors = [];

      if (!this.$v.item.maintenance.$dirty) return errors;

      has(this.violations, 'maintenance') && errors.push(this.violations.maintenance);


      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {

  },
  validations: {
    item: {
      name: {
        required,
      },
      duration: {
        required,
      },
      description: {

      },
      guarantee: {

      },
      maintenance: {

      },
    }
  }
};
</script>
